import * as Yup from 'yup';
import { FC, useState } from 'react';
import { useFormik } from 'formik';
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Button,
  Typography
} from '@mui/material';
import TextField from '@mui/material/TextField';
import request from '../../../../utils/request';
import { LoadingButton } from '@mui/lab';
import SnackbarAlert from '../../../common/SnackbarAlert';
import React from 'react';
import AutocompleteLoader from '../../../common/AutocompleteLoader';

const machineNameRegExp = /^[a-z0-9]+$/;

type CreateEditProps = {
  closeCreateEditForm: any;
  assetTypeEditDatas: any;
  editStatus: boolean;
  productId: any;
  setNewValue?: Function;
};
const CreateEdit: FC<CreateEditProps> = ({
  closeCreateEditForm,
  assetTypeEditDatas,
  editStatus,
  productId,
  setNewValue
}) => {
  const MachineTypeSchema = Yup.object().shape({
    assetCode: Yup.string()
      .required('Asset Code is required'),
      // .matches(
      //   /^[a-z0-9A-Z\s\-]+$/,
      //   'Invalid Asset Code. Only (-) character is allowed.'
      // )
      // .min(3, 'Asset Code must be at least 3 characters')
      // .matches(
      //   /^[^-!@#$%^&*()_+={};:'",.<>/?\\|[\]`~].*$/,
      //   'Asset Code cannot start with a special character'
      // )

      // .trim('Asset Code cannot include leading and trailing spaces'),
    assetName: Yup.string()
      .min(3, 'Asset Name must be at least 3 characters')
      // .matches(
      //   // eslint-disable-next-line no-useless-escape
      //   /^[a-zA-Z0-9\s\[\]\-\(\)&\/\\,]*$/,
      //   'Asset Name only accepts special characters like &,[,],-,/,(,),'
      // )
      // .matches(
      //   /[a-zA-Z]/,
      //   'Asset Name must include at least one letter of the alphabet'
      // )
      // .test(
      //   'no-leading-space',
      //   'Cannot start with a space',
      //   (value) => !value || value.trimStart() === value
      // )
      .required('Asset Name is required')

      .trim('Asset Name cannot include leading and trailing spaces'),
    assetRate: Yup.number()
      //.required('Asset Rate is required')
      //.typeError('Asset Rate is not valid')
      .positive('Must be a positive number.')

      .transform((value, originalValue) =>
        /\s/.test(originalValue) ? NaN : value
      )
      .test(
        'len',
        'Length is too long',
        (val) =>
          !val ||
          (val && val.toString().includes('.')
            ? val.toString().length <= 10
            : val.toString().length <= 8)
      )
      .test(
        'max-two-decimals',
        'Asset Rate can have at most 2 decimal places',
        (value) => {
          if (value === undefined || value === null) return true;
          const decimalPlaces = value.toString().split('.')[1];
          return !decimalPlaces || decimalPlaces.length <= 2;
        }
      )
  });

  const [loader, setLoader] = useState(false);
  const [productLoader, setProductLoader] = useState(null);
  const [policyProductData, setPolicyProductData] = useState([]);
  const [policyProductValue, setPolicyProductValue] = useState('');
  const [policyProductSearchValue, setPolicyProductSearchValue] = useState('');
  const [noOptionsTextFlag, setNoOptionsTextFlag] = useState(false);
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const formik = useFormik({
    initialValues: {
      id: '',
      productId: null,
      // machineType: '',
      assetCode: '',
      assetName: '',
      assetRate: '',
      status: true
    },
    validationSchema: MachineTypeSchema,
    onSubmit: (values) => {
      values.assetRate = String(values.assetRate);
      values.productId = productId;
      setLoader(true);
      const method = editStatus ? 'PUT' : 'POST';
      request({
        url: 'assetType',
        method: method,
        data: values
      })
        .then((assetType) => {
          if (assetType.status) {
            closeCreateEditForm(true);
            setLoader(false);
            if (setNewValue) {
              setNewValue(values?.assetName);
            }
          } else {
            setLoader(false);
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: assetType['message']
            });
          }
          closeCreateEditForm();
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
        });
    }
  });

  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  if (editStatus) {
    formik.values.id = assetTypeEditDatas.id;
    formik.initialValues.assetCode = assetTypeEditDatas.assetCode;
    formik.initialValues.assetName = assetTypeEditDatas.assetName;
    formik.initialValues.assetRate = assetTypeEditDatas.assetRate;
  }

  React.useEffect(() => {
    if (editStatus) {
      formik.initialValues.productId = assetTypeEditDatas.productId;
      setPolicyProductSearchValue(assetTypeEditDatas.policyProduct?.name);
      setPolicyProductValue(assetTypeEditDatas.policyProduct);
    }
  }, [editStatus]);
  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  //Product fdetch api
  React.useEffect(() => {
    getpolicyProductData();
  }, [policyProductSearchValue]);

  const getpolicyProductData = () => {
    setProductLoader(true);
    setPolicyProductData([]);
    request({
      url: 'policyProduct/getAllowedPolicyProducts',
      method: 'post'
    }).then(
      (response: any) => {
        setProductLoader(false);
        if (response?.status == false) {
          setNoOptionsTextFlag(true);
          setPolicyProductData([]);
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: response.message
          });
        } else {
          setNoOptionsTextFlag(false);
          setPolicyProductData(response);
        }
      },
      (error) => {
        setProductLoader(false);
        console.log(error);
      }
    );
  };

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Card>
              {editStatus ? (
                <CardHeader title="Update Asset Type" />
              ) : (
                <CardHeader title="Create Asset Type" />
              )}

              <CardContent>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        type="text"
                        label={
                          <React.Fragment>
                            Asset Name{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="assetName"
                        value={capitalizeFirst(formik.values.assetName)}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.assetName &&
                          Boolean(formik.errors.assetName)
                        }
                        helperText={
                          formik.touched.assetName && formik.errors.assetName
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Asset Code{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="assetCode"
                        value={capitalizeFirst(formik.values.assetCode)}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.assetCode &&
                          Boolean(formik.errors.assetCode)
                        }
                        helperText={
                          formik.touched.assetCode && formik.errors.assetCode
                        }
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        // label={
                        //   <React.Fragment>
                        //     Asset Rate{' '}
                        //     <Typography
                        //       component="span"
                        //       sx={{ color: 'red' }}
                        //     >
                        //       *
                        //     </Typography>
                        //   </React.Fragment>
                        // }
                        label={'Asset Rate'}
                        sx={{ width: '100%' }}
                        type="number"
                        onKeyDown={(e) => {
                          if (['e', 'E', '-', '+'].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        size="small"
                        name="assetRate"
                        value={formik.values.assetRate}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.assetRate &&
                          Boolean(formik.errors.assetRate)
                        }
                        helperText={
                          formik.touched.assetRate && formik.errors.assetRate
                        }
                      />
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                      mt={2}
                    >
                      {loader ? (
                        <LoadingButton
                          sx={{ mt: { xs: 2, md: 0 } }}
                          loading={loader}
                          variant="contained"
                          type="submit"
                        >
                          Save
                        </LoadingButton>
                      ) : (
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          type="submit"
                          variant="contained"
                        >
                          Save
                        </Button>
                      )}
                      &nbsp;
                      <Button
                        sx={{ mt: { xs: 2, md: 0 } }}
                        variant="contained"
                        color="error"
                        onClick={closeCreateEditForm}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default CreateEdit;
